/**
 * Microphone gain stage: pipes a mic MediaStream through a WebAudio GainNode
 * so a quiet mic can be boosted (gain > 100%) or a hot one tamed (< 100%).
 * getUserMedia has no volume constraint — this graph is the only reliable,
 * cross-browser way to change the captured level.
 *
 * dispose() closes ONLY this graph's AudioContext; the caller owns the input
 * stream and is responsible for stopping its tracks (so the stage composes
 * cleanly with the RNNoise graph, which has its own lifecycle).
 */
export interface BoostedStream {
  stream: MediaStream;
  dispose: () => void;
}

export function boostMic(input: MediaStream, gainPct: number): BoostedStream {
  const ctx = new AudioContext();
  const src = ctx.createMediaStreamSource(input);
  const gain = ctx.createGain();
  gain.gain.value = Math.max(0, gainPct / 100);
  const dest = ctx.createMediaStreamDestination();
  src.connect(gain);
  gain.connect(dest);

  return {
    stream: dest.stream,
    dispose: () => {
      try {
        void ctx.close();
      } catch {
        /* already closed */
      }
    },
  };
}
